export const admin = {
  // 대시보드
  dashboardTitle: '운영 대시보드',
  dashboardSubtitle: '관리 기능의 입구입니다. 모든 화면은 읽기 전용입니다(수정은 각 전용 화면에서).',
  adminBadge: 'Admin',
  loggedInAs: '로그인 중',

  // 입구 링크 카드
  linksTitle: '관리 기능',
  matchingTitle: '매칭 관리',
  matchingDesc: '희망 요청 페어링 및 확정',
  wordPoolTitle: 'Word Pool 승인',
  wordPoolDesc: '제출 단어 심사, 단체 신청 승인',
  levelCheckTitle: '레벨 체크 결과',
  levelCheckDesc: '응시 결과 목록 및 합격 여부 확인',
  open: '열기 →',

  // 탭
  tabUsers: '사용자',
  tabBilling: '결제 현황',
  tabApplications: '단체 신청',
  tabSignups: '모집 명부',

  // 사용자 목록
  usersTitle: '사용자 목록',
  usersSearchPlaceholder: '이름·이메일로 검색',
  colName: '이름',
  colEmail: '이메일',
  colNative: '모국어',
  colTarget: '학습 언어',
  colLevel: '레벨',
  colOrg: '단체',
  colSubStatus: '결제',
  filterAll: '전체',
  filterMembers: '개인',
  filterOrg: '단체 소속',
  subNone: '미등록',
  subActive: '활성',
  subPaused: '일시정지',
  subCancelled: '해지됨',
  noUsers: '해당하는 사용자가 없습니다',

  // 결제 현황
  billingTitle: '결제 현황',
  billingDesc: '구독 중인 사용자 목록입니다.',
  colPlan: '플랜',
  colRemaining: '잔여 레슨',
  colRollover: '이월',
  colPeriodEnd: '다음 갱신',
  noBilling: '활성 구독이 없습니다',

  // 단체 신청
  applicationsTitle: '단체 신청(심사 대기)',
  applicationsNote: '이 화면은 읽기 전용입니다. 승인·반려는 Word Pool 관리 화면에서 진행하세요.',
  colOrgName: '단체명',
  colType: '종류',
  colSchedulingMode: '스케줄',
  colApplicantUser: '신청자',
  colIdDocument: '신분증',
  colCreatedAt: '신청 일시',
  hasIdDocument: '있음',
  noIdDocument: '없음',
  noApplications: '심사 대기 중인 단체 신청이 없습니다',
  goToWordPoolApprove: 'Word Pool 관리에서 승인 →',

  // 모집 명부
  signupsTitle: '모집 명부(커뮤니티 등록)',
  colSignupName: '이름',
  colOrganizationName: '단체명',
  colConsent: '게재 동의',
  colStatus: '상태',
  consentYes: '동의함',
  consentNo: '없음',
  noSignups: '모집 명부 데이터가 없습니다',
  signupsUnavailable: '모집 명부 테이블이 설정되지 않았거나 접근 권한이 없습니다.',

  // 무료 모드(FREE_MODE) 전환
  freeModeTitle: '무료 모드(결제 ON/OFF)',
  freeModeDesc: '무료 모드가 ON인 동안에는 플랜 선택 화면에서 결제 동선을 표시하지 않고 체크아웃도 생성하지 않습니다(오결제 방지). OFF로 하면 기존 유료 플랜 선택이 활성화됩니다.',
  freeModeCurrentLabel: '현재 상태',
  freeModeOn: '무료 모드(결제 OFF)',
  freeModeOff: '유료 모드(결제 ON)',
  freeModeTurnOff: '유료 모드로 전환(결제 활성화)',
  freeModeTurnOn: '무료 모드로 전환(결제 중지)',
  freeModeUpdating: '업데이트 중...',
  freeModeUpdateError: '무료 모드 업데이트에 실패했습니다.',
  freeModeLoadError: '무료 모드 상태를 불러오지 못했습니다(기본값: 무료).',

  // 매칭: Google Meet 자동 생성
  meetGenerateButton: 'Google Meet 자동 생성',
  meetGenerating: '생성 중...',
  meetGenerateSuccess: 'Google Meet 링크를 생성했습니다.',
  meetFallbackNotice: '자동 생성이 비활성화되어 있습니다. Meet 링크를 직접 입력해 주세요.',
  meetGenerateError: 'Meet 자동 생성에 실패했습니다. Meet 링크를 직접 입력해 주세요.',

  // 공통 상태
  loading: '로딩 중...',
  loadError: '데이터를 불러오지 못했습니다.',
  showingCount: '{{count}}건',

  // ── Word Pool 승인 관리 화면 (admin/word-pool) ──
  wordPoolAdmin: {
    statusPending: '승인 대기',
    statusApproved: '승인됨',
    statusRejected: '반려',
    heading: 'Word Pool 승인 관리',
    adminLabel: 'Admin: ',
    toLevelCheck: '레벨 체크 결과 →',
    filterAll: '전체',
    empty: '해당하는 등록 내역이 없습니다',
    lessonLabel: '레슨: ',
    commentPlaceholder: '코멘트(선택)',
    approve: '승인',
    reject: '반려',
    commentLabel: '코멘트: ',
  },

  // ── 레벨 체크 결과 화면 (admin/level-check-results) ──
  levelCheckAdmin: {
    heading: '레벨 체크 결과',
    adminLabel: 'Admin: ',
    toWordPool: '← Word Pool 관리',
    statTotal: '총 응시 수',
    statPassed: '합격',
    statFailed: '불합격',
    statAvgScore: '평균 점수',
    filterLanguage: '언어:',
    filterLevel: '레벨:',
    filterPassed: '합격 여부:',
    filterAll: '전체',
    levelPrefix: 'Lv.',
    levelLabel: 'Level',
    empty: '해당하는 결과가 없습니다',
    passed: '합격',
    failed: '불합격',
    member: '회원',
    wrongQuestions: '오답: 문제 {{questions}}',
    scoreUnit: '점',
  },

  // ── 매칭 관리 화면 (admin/matching) ──
  matching: {
    confirmSuccess: '매칭을 확정했습니다! 두 사용자에게 이메일을 전송했습니다.',
    errorPrefix: '오류: ',
    heading: '매칭 관리',
    adminLabel: 'Admin: ',
    toWordPool: 'Word Pool 승인 →',
    toLevelCheck: '레벨 체크 결과 →',
    pairConfirm: '페어 확정',
    compatibilityScore: '상성 점수',
    scoreLang: '언어',
    scoreTime: '시간대',
    scoreTz: 'TZ차',
    breakdownLang: '① 언어 일치(이해관계)',
    breakdownTime: '② 시간대 중복',
    breakdownTz: '③ TZ차(참고)',
    langFull: '✅ 완전 일치',
    langPartial: '⚠️ 한쪽만',
    langNone: '❌ 불일치',
    slotsOverlap: '{{count}} 슬롯 중복',
    slotsNone: '중복 없음',
    tzDiff: 'UTC차 {{hours}}시간',
    langScore: '{{score}} / 50점',
    timeScore: '{{score}} / 40점',
    tzScore: '{{score}} / 10점',
    choice: '{{n}}순위 희망：',
    meetLinkLabel: 'Google Meet 링크',
    worksheetLabel: '워크시트 PDF URL',
    worksheetHint: '(선택 — 입력하면 이메일에 링크가 추가됩니다)',
    worksheetHelper: 'Supabase Storage의 worksheets 버킷에 PDF를 업로드하고 공개 URL을 붙여넣어 주세요',
    confirming: '확정 중...',
    confirmPair: '이 페어로 확정하기',
    cancel: '취소',
    empty: '현재 매칭 대기 중인 요청이 없습니다',
    selectTwo: '페어로 만들 사용자 2명을 선택해 주세요(현재 {{count}}건의 요청)',
    nativeBadge: '모국어: {{lang}}',
    learningBadge: '학습: {{lang}}',
    pointSuffix: '점',
    confirmedSlotLabel: '확정 레슨 일시',
    confirmedSlotPlaceholder: '일시를 선택（양측 공통 희망 권장）',
    slotOverlapSuffix: '（공통 희망）',
    slotNoOverlapWarn: '⚠ 양측의 공통 희망 시간이 없습니다. 수동 선택 시 상대방의 사정을 확인해 주세요.',
    selectSlotFirst: '확정 레슨 일시를 먼저 선택해 주세요.',
    recommendTitle: '추천 페어',
    recommendDesc: '상성 점수순 자동 랭킹입니다. "이 페어 선택"으로 확정 패널로 이동합니다.',
    selectThisPair: '이 페어 선택',
    sharedSlotPrefix: '공통: ',
    noShared: '공통 시간 없음',
    noRecommend: '추천 후보가 없습니다',
    recommendScore: '상성 {{score}}/100',
  },
};
